import React from 'react';
import PropTypes from 'prop-types';
import _debounce from 'lodash/debounce';
import AppStore from '../stores/AppStore';
import * as AppActions from '../actions/AppActions';
import TemplateData from '../utility/getTemplateData';
import { fetcher } from '../utility/domUtils';
import { SingleAmount } from '@paypalcorp/donate-react';
import { BodyText } from '@paypalcorp/pp-react';
import Calculator from '../components/amount/calculator';
import PresetAmountRow from './amount/PresetAmountRow';
import {
  setFeeAmountInStore,
  optOutCoverFee,
  isAtLandingPage,
  isOptInCoverFee,
} from './coverFee/feeUtils';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { getParameterByName } from '../utility/queryStringHelper';
import { __getInitialData } from '../utility/formator';
import { trackErrorIM } from '../fpti/fpti';
import { addFeature, setAmountTypeFpti } from '../fpti/helper';
import { FEATURES } from '../fpti/fptiConstants';
import { getWorldReady } from '../utility/worldReadyUtils';
import { MessageFormat } from '@paypalcorp/worldready';

class AmountWrapper extends React.Component {
  constructor(props) {
    super(props);
    const currencyObj = JSON.parse(
      document.getElementById('currencyLists').innerHTML || {}
    );
    const { currencies: currencyLists, symbols: currencySymbols } =
      currencyObj || {};
    const html = document.getElementsByTagName('html')[0];
    this.directionality = html.getAttribute('dir');

    const userCountry = TemplateData.donorIpCountry;
    const availableCurrencies = currencyLists[userCountry] || currencyLists.US;
    const userAmountCode = availableCurrencies[0];
    const charityAmountCode = AppStore.getDonationCode();
    const isEditable = !!TemplateData.donationAmountEditable;
    // let showCBCalculator = TemplateData.pxp && TemplateData.pxp.calculator && TemplateData.pxp.calculator.experiment || false;

    const isCalculator = false;
    // Disabled Calculator
    // let isCalculator =
    // 	isEditable &&
    // 	userAmountCode !== charityAmountCode &&
    // 	(showCBCalculator || TemplateData.isCorpIp);

    this.state = {
      charityAmountCode,
      charityAmount: AppStore.getDonationAmount() || '',
      charityAmountSymbol: AppStore.getDonationSymbol(),
      charityDisabled: false,

      userCountry,
      userAmountCode,
      userAmount: '',
      userDisabled: false,

      availableCurrencies,
      currencySymbols,
      isCalculator,
      decimalPoint: TemplateData.donationDecimalPoint || '.',
      conversionRate: '',
      isAmountEditable: isEditable,

      showValidationError: props.showValidationError || false,
      validationErrorMessage: props.validationErrorMessage || '',
      validationErrorCode: props.validationErrorCode || '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.showValidationError !== nextProps.showValidationError) {
      this.setState({
        showValidationError: nextProps.showValidationError,
        validationErrorMessage: nextProps.validationErrorMessage,
        validationErrorCode: nextProps.validationErrorCode,
      });
    }
  }

  componentDidMount = () => {
    // Watch for amount change for the case that donor opts in to cover fee
    // and clicks back button to go back to landing page
    // as we need to restore donor's original entered amount
    this.dispatcherCharityAmount = AppDispatcher.register((payload) => {
      if (payload.action && payload.action.actionType === 'CHANGE_AMOUNT') {
        const { action: { item: { amount = 0 } = {} } = {} } = payload;
        this.setState({
          charityAmount: amount,
        });
      }
    });

    if (this.state.isAmountEditable) {
      addFeature(FEATURES.DONATION_AMOUNT_EDITABLE);
    }
  };

  componentWillUnmount = () => {
    AppDispatcher.unregister(this.dispatcherCharityAmount);
  };

  isGuestReviewPage = () => {
    return (
      window.location.pathname.includes('guest') ||
      ![undefined, null].includes(getParameterByName('signup'))
    );
  };

  normalizeAmount = (amount) => {
    return isNaN(amount) ? 0 : amount;
  };

  setAppAmount = (amount) => {
    AppActions.changeAmount({
      amount,
    });
  };

  getConversionRate = (state, exchangeRate) => {
    const rate =
      exchangeRate.base_currency_code === state.userAmountCode
        ? exchangeRate.quote_amount
        : 1 / exchangeRate.quote_amount;
    return rate.toFixed(2);
  };

  getConversionRequest = (state, params, callback) => {
    this.getConversionRequest = _debounce((st, par, fn) => {
      const queryParams = {
        fromCountry: st.userCountry,
        fromCurrency: st.userAmountCode,
        toCurrency: st.charityAmountCode,
        ...par,
      };

      if (queryParams.fromAmount) {
        queryParams.fromAmount = this.normalizeAmount(queryParams.fromAmount);
      } else {
        queryParams.toAmount = this.normalizeAmount(queryParams.toAmount);
      }
      const url = '/donate/calculate-foreign-exchange';
      this.props.conversionStatus(true);
      Promise.resolve(
        fetcher(url, {
          method: 'POST',
          body: JSON.stringify(queryParams),
        })
      )
        .then((response) => response.json())
        .then(({ result }) => {
          this.props.conversionStatus(false);
          fn(result);
        })
        .catch(() => {
          this.props.conversionStatus(false);
          let amount = queryParams.fromAmount || queryParams.toAmount || '';
          amount += '';
          fn({
            target: { value: amount },
            source: { value: amount },
            exchange_rate: {
              base_currency_code: queryParams.userAmountCode,
              quote_amount: 1,
            },
          });
        });
    }, 500);

    this.getConversionRequest(state, params, callback);
  };

  /*
   * getConversion
   * Getting conversion rate for calculator
   */
  getConversion = (state, params, fn) => {
    // Conversion is only required for calculator
    if (state.isCalculator) {
      this.getConversionRequest(state, params, fn);
    } else {
      const amount = params.fromAmount || params.toAmount || '';
      fn({
        target: { value: amount },
        source: { value: amount },
        exchange_rate: {
          base_currency_code: state.userAmountCode,
          quote_amount: 1,
        },
      });
    }
  };

  handleAmountChange = (amount) => {
    this.setState({ charityAmount: amount });
    this.setAppAmount(amount);

    // let recurringStatus = AppStore.getDonationRecurring() === 'checked';
    // if (recurringStatus) {
    //   if (isAmountGreaterThanZero(amount)) {
    //     $('#donateNowAmt').html(this.state.charityAmountSymbol + amount);
    //   } else {
    //     $('#donateNowAmt').html(' ');
    //   }
    // }

    if (isAtLandingPage()) {
      // Compute fee amount and update store
      setFeeAmountInStore();
      // Let landing page know that fee amount displayed needs to be updated
      this.props.updateFeeAmount();
    } else {
      // Since user updates the amount in the guest page
      // we should opt user out for cover the fee in case
      // they go back to landing page
      if (isOptInCoverFee()) {
        optOutCoverFee();
      }

      // In case user selects a preset button but update the amount
      // in review page, the donation amount type should now be
      // "userinput"
      if (AppStore.getDonationAmountType() === 'preset') {
        setAmountTypeFpti('other');
        AppActions.updateDonationAmountType('userinput');
      }
    }
  };

  handleAmountFocus() {
    this.props.onFocus();
  }

  handleUserAmountChange = (amount) => {
    const snapshot = {
      userAmount: amount,
      charityDisabled: true,
    };
    const state = { ...this.state, ...snapshot };
    this.setState(snapshot);

    this.getConversion(
      state,
      {
        fromAmount: state.userAmount,
      },
      ({ target, exchange_rate }) => {
        this.setState({
          conversionRate: this.getConversionRate(state, exchange_rate),
          charityAmount: target.value,
          charityDisabled: false,
        });
        this.setAppAmount(target.value);
      }
    );
  };

  handleUserCurrencyChange = (currencyCode) => {
    const snapshot = {
      userAmountCode: currencyCode,
      charityDisabled: true,
    };
    const state = { ...this.state, ...snapshot };
    this.setState(snapshot);

    this.getConversion(
      state,
      {
        fromAmount: state.userAmount,
      },
      ({ target, exchange_rate }) => {
        state.charityAmount = target.value;
        this.setState({
          conversionRate: this.getConversionRate(state, exchange_rate),
          charityAmount: state.charityAmount,
          charityDisabled: false,
        });
        this.setAppAmount(target.value);
      }
    );
  };

  handleCharityAmountChange = (amount) => {
    const snapshot = {
      charityAmount: amount,
      userDisabled: true,
    };
    const state = { ...this.state, ...snapshot };
    this.setState(snapshot);

    this.getConversion(
      state,
      {
        toAmount: state.charityAmount,
      },
      ({ source, exchange_rate }) => {
        this.setState({
          conversionRate: this.getConversionRate(state, exchange_rate),
          userAmount: source.value,
          userDisabled: false,
        });
        this.setAppAmount(state.charityAmount);
      }
    );
  };

  handleTrackError = (errorCode, errorString, errorSourceField) => {
    trackErrorIM({
      errorCode: errorCode || 'DONATION_AMOUNT_VALIDATION_ERROR',
      errorMessage: errorString,
      fieldName: errorSourceField,
    });
  };

  shouldShowPresetAmounts = () => {
    // Should only show preset amount options in landing
    // page not review page to make the experience consistent
    // with member flow. It works better for cover the fees as well

    const presetAmountsCondition =
      TemplateData.enablePresetAmounts &&
      !this.state.isCalculator &&
      !this.isGuestReviewPage();

    if (presetAmountsCondition) {
      addFeature(FEATURES.PRESET);
    }

    return presetAmountsCondition;
  };

  renderPresetAmounts = () => {
    return (
      <PresetAmountRow
        charityAmount={this.state.charityAmount}
        charityAmountSymbol={this.state.charityAmountSymbol}
        charityAmountCode={this.state.charityAmountCode}
        decimalPoint={this.state.decimalPoint}
        isAmountEditable={this.state.isAmountEditable}
        handleAmountChange={this.handleAmountChange.bind(this)}
        handleAmountFocus={this.handleAmountFocus.bind(this)}
        hideValidationError={this.props.hideValidationError}
        showValidationError={this.state.showValidationError}
        validateDonationAmount={this.props.validateDonationAmount}
        validationErrorMessage={this.state.validationErrorMessage}
        validationErrorCode={this.state.validationErrorCode}
      />
    );
  };

  getRecurringLabel = () => {
    const worldReady = getWorldReady();
    switch (this.props.selectedRecurringFrequency) {
      case 'Week':
        return new MessageFormat(worldReady, {
          id: 'guest.guestForm.label.perWeek',
        }).format();
      case 'Month':
        return new MessageFormat(worldReady, {
          id: 'guest.guestForm.label.perMonth',
        }).format();
      case 'Year':
        return new MessageFormat(worldReady, {
          id: 'guest.guestForm.label.perYear',
        }).format();
      default:
        return null;
    }
  };

  render() {
    if (this.shouldShowPresetAmounts()) {
      return (
        <div className="preset-amount-wrapper">
          {this.renderPresetAmounts()}
        </div>
      );
    }

    return (
      <div className="amount-wrapper">
        {this.state.isCalculator ? (
          <Calculator
            availableCurrencies={this.state.availableCurrencies}
            charityAmountSymbol={this.state.charityAmountSymbol}
            currencySymbols={this.state.currencySymbols}
            decimalPoint={this.state.decimalPoint}
            conversionRate={this.state.conversionRate}
            fromAmount={this.state.userAmount}
            fromCode={this.state.userAmountCode}
            fromDisabled={this.state.userDisabled}
            toAmount={this.state.charityAmount}
            toCode={this.state.charityAmountCode}
            toDisabled={this.state.charityDisabled}
            handleFromChange={this.handleUserAmountChange.bind(this)}
            handleFromCurrencyChange={this.handleUserCurrencyChange.bind(this)}
            handleToChange={this.handleCharityAmountChange.bind(this)}
            toError={this.state.showValidationError}
            toErrorMessage={this.state.validationErrorMessage}
            handleAmountFocus={this.handleAmountFocus.bind(this)}
          />
        ) : (
          <>
            <div
              className={`amount ${
                !this.state.showValidationError ? 'no-error' : ''
              }`}
            >
              <SingleAmount
                amount={this.state.charityAmount}
                currencyCode={this.state.charityAmountCode}
                currencySymbol={this.state.charityAmountSymbol}
                handleAmount={this.handleAmountChange.bind(this)}
                showValidationError={this.state.showValidationError}
                validationErrorMessage={this.state.validationErrorMessage}
                isEditable={this.state.isAmountEditable}
                handleAmountFocus={this.handleAmountFocus.bind(this)}
                getAmountBeforeFee={AppStore.getAmountBeforeFee}
                isOptInCoverFee={isOptInCoverFee}
                isAtLandingPage={isAtLandingPage}
                clientMetadata={__getInitialData().clientMetadata}
                handleTrackError={this.handleTrackError}
                validationErrorCode={this.state.validationErrorCode}
                directionality={this.directionality}
              />
              {AppStore.getDonationRecurring() === 'checked' && (
                <BodyText strong>{this.getRecurringLabel()}</BodyText>
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}

AmountWrapper.propTypes = {
  conversionStatus: PropTypes.func,
  showValidationError: PropTypes.bool,
  hideValidationError: PropTypes.func,
  validationErrorMessage: PropTypes.string,
  validationErrorCode: PropTypes.string,
  validateDonationAmount: PropTypes.func,
  onFocus: PropTypes.func,
  updateFeeAmount: PropTypes.func,
  selectedRecurringFrequency: PropTypes.string,
};

export default AmountWrapper;
